/* Distantlines Mama Definitionsposter Editor — Build 2026-05-02-13:00.
 * Gebündelt aus 11 ES-Modulen.
 * Quelle: ~/Code/mama-poster-preview/js/ (Standalone-Preview)
 * Reihenfolge: state -> render -> photo-upload -> produkt -> quality
 *   -> text-inputs -> passepartout -> filter -> inspirations -> main
 * inspirations.json inline embedded.
 */
(function () {
  'use strict';
const __INSPIRATIONS_DATA__ = {
  "categories": [
    { "id": "mama", "label": "Mama" },
    { "id": "papa", "label": "Papa" },
    { "id": "oma", "label": "Oma" },
    { "id": "opa", "label": "Opa" },
    { "id": "schwester", "label": "Schwester" },
    { "id": "bruder", "label": "Bruder" },
    { "id": "familie", "label": "Familie" }
  ],
  "templates": {
    "mama": [
      {
        "title": "Powermama",
        "hauptwort": "Mama",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie liebt ohne Bedingung, kämpft ohne zu zögern und gibt, ohne je zu fragen, was zurückkommt. Mit Mut, Wärme und einem unerschütterlichen Willen meistert sie jeden Tag - und macht ihn für die Menschen um sie herum besser.",
        "definition_p2": "Sie ist nicht nur Mutter. Sie ist Heldin, Halt und Vorbild zugleich.",
        "synonyme": "Powerfrau · Kämpferin · Heldin"
      },
      {
        "title": "Behütende Mama",
        "hauptwort": "Mama",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie hört zu, bevor sie urteilt. Sie tröstet, bevor man fragt. Sie ist da - leise, verlässlich, immer. In ihrer Nähe wird die Welt ein bisschen kleiner und sicherer.",
        "definition_p2": "Bei ihr darf man Kind sein, auch wenn man längst erwachsen ist.",
        "synonyme": "Schutz · Zuhause · Geborgenheit"
      },
      {
        "title": "Beste Freundin",
        "hauptwort": "Mama",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Erst Mutter, dann Komplizin. Sie lacht über die gleichen Witze, kennt jede Geschichte und sagt die Wahrheit, auch wenn sie weh tut. Mit ihr teilt man Kaffee, Gedanken und manchmal auch das Glas Wein zu viel.",
        "definition_p2": "Sie ist Familie und Lieblingsmensch in einer Person.",
        "synonyme": "Vertraute · Komplizin · Seelenverwandte"
      },
      {
        "title": "Sonnenschein",
        "hauptwort": "Mama",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie betritt einen Raum und das Licht wird wärmer. Ihr Lachen ist ansteckend, ihre Energie hält jede Familie zusammen. Selbst an grauen Tagen findet sie etwas, worüber man lächeln kann.",
        "definition_p2": "Wo sie ist, wird es heller.",
        "synonyme": "Lebensfreude · Herzensmensch · Lichtblick"
      },
      {
        "title": "Heldin im Alltag",
        "hauptwort": "Mama",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie jongliert Termine, Sorgen und To-do-Listen - und schafft es trotzdem, abends warm zu lächeln. Was sie leistet, sieht niemand auf den ersten Blick. Aber ohne sie würde nichts laufen.",
        "definition_p2": "Eine stille Heldin. Ohne Cape, aber mit Plan.",
        "synonyme": "Macherin · Anker · Organisationstalent"
      }
    ],
    "papa": [
      {
        "title": "Bester Papa",
        "hauptwort": "Papa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er steht auf, bevor andere wach sind, und legt sich erst hin, wenn alle versorgt sind. Er gibt mehr, als er nimmt - und sagt selten, wie viel ihn das kostet. Verlässlich, ehrlich, da.",
        "definition_p2": "Ein Vater, wie ihn jeder verdient hätte.",
        "synonyme": "Fels · Vorbild · Geber"
      },
      {
        "title": "Held der Kindheit",
        "hauptwort": "Papa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Schultern zum Klettern, Hände zum Festhalten, Geschichten zum Einschlafen. Bei ihm war jede Höhle ein Königreich und jeder Schrammen halb so wild. Er hat die Kindheit groß gemacht.",
        "definition_p2": "Manche Helden tragen keinen Umhang. Sie tragen einen alten Pulli und riechen nach Zuhause.",
        "synonyme": "Beschützer · Abenteurer · Kindheitsheld"
      },
      {
        "title": "Lieblingsmensch",
        "hauptwort": "Papa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Wenig Worte, viel Wärme. Er sagt nicht oft, was er fühlt - aber man spürt es in jeder Geste. In der Art, wie er fragt, wie es geht. In der Art, wie er da ist, wenn es zählt.",
        "definition_p2": "Manchmal sind die leisen Menschen die wichtigsten.",
        "synonyme": "Vertrauter · Stiller Held · Halt"
      },
      {
        "title": "Ratgeber",
        "hauptwort": "Papa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er hat auf fast jede Frage eine Antwort - und auf den Rest einen guten Rat. Er erklärt, ohne zu belehren. Er hört zu, ohne zu unterbrechen. Sein Kompass hat schon viele durchs Leben getragen.",
        "definition_p2": "Wenn er etwas sagt, dann hat es Gewicht.",
        "synonyme": "Mentor · Wegweiser · Vertrauter"
      }
    ],
    "oma": [
      {
        "title": "Beste Oma",
        "hauptwort": "Oma",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Bei ihr riecht es nach Kuchen, Kaffee und einer Kindheit, die nie ganz zu Ende geht. Sie hat für jeden eine Umarmung, für jede Geschichte Zeit und für jedes Problem ein gutes Wort.",
        "definition_p2": "Ein Zuhause auf zwei Beinen.",
        "synonyme": "Wärme · Nest · Lieblingsmensch"
      },
      {
        "title": "Geschichten-Erzählerin",
        "hauptwort": "Oma",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie erinnert sich an Dinge, die längst vergessen schienen. Namen, Jahre, Gesichter - bei ihr lebt alles weiter. Wenn sie erzählt, hört die Welt für einen Moment auf, sich zu drehen.",
        "definition_p2": "Sie ist ein Stück Familiengeschichte mit eigenem Lachen.",
        "synonyme": "Bewahrerin · Chronistin · Erzählerin"
      },
      {
        "title": "Herz aus Gold",
        "hauptwort": "Oma",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie gibt, ohne zu rechnen. Sie liebt, ohne zu fragen. Was andere übersehen, sieht sie zuerst - und kümmert sich, ohne ein Wort zu verlieren. So macht man Menschen groß.",
        "definition_p2": "Ihr Herz war immer schon das größte am Tisch.",
        "synonyme": "Engel · Seele · Liebe"
      },
      {
        "title": "Wärme",
        "hauptwort": "Oma",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Eine Decke, eine Tasse Tee, ihre Stimme im Hintergrund. Bei ihr wird die Welt langsamer und freundlicher. Man muss nichts leisten, nichts beweisen - man darf einfach nur da sein.",
        "definition_p2": "Bei Oma ist alles für einen Moment in Ordnung.",
        "synonyme": "Geborgenheit · Ruhe · Heimat"
      }
    ],
    "opa": [
      {
        "title": "Werkstatt-Held",
        "hauptwort": "Opa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er kann alles reparieren, was kaputt ist - und vieles, was es gar nicht war. In seinen Händen wird aus alten Dingen wieder Neues. Er erklärt nicht viel; er zeigt es einfach.",
        "definition_p2": "Geduld, Holz und Werkzeug - daraus ist er gemacht.",
        "synonyme": "Macher · Tüftler · Allrounder"
      },
      {
        "title": "Geschichten-Onkel",
        "hauptwort": "Opa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er hat schon fast alles erlebt - und erzählt es auch gerne zweimal. Seine Geschichten sind länger als die meisten Bücher und hängen einem trotzdem nicht hinten raus. Bei ihm lernt man Dinge, die in keiner Schule stehen.",
        "definition_p2": "Ein wandelnder Schatz aus Erinnerungen.",
        "synonyme": "Erzähler · Zeitzeuge · Lebenskünstler"
      },
      {
        "title": "Cooler Opa",
        "hauptwort": "Opa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er nimmt das Leben mit Humor und sich selbst nicht zu ernst. Er kennt mehr Witze als die meisten Leute Bekannte haben. Mit ihm ist Langeweile ein Fremdwort.",
        "definition_p2": "Man wird älter. Aber bei ihm fühlt man sich plötzlich wieder zwölf.",
        "synonyme": "Lebenskünstler · Witzbold · Original"
      },
      {
        "title": "Mentor",
        "hauptwort": "Opa",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er teilt sein Wissen, ohne sich darauf etwas einzubilden. Er gibt Rat, ohne zu drängen. Was er weiß, hat er sich erarbeitet - und genau so reicht er es weiter.",
        "definition_p2": "Bei ihm lernt man fürs Leben, nicht für die Schule.",
        "synonyme": "Lehrer · Wegbereiter · Vorbild"
      }
    ],
    "schwester": [
      {
        "title": "Beste Schwester",
        "hauptwort": "Schwester",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie kennt einen seit dem ersten Atemzug - die guten Seiten und die, die niemand sehen darf. Sie streitet, sie versöhnt, sie hält. Wer sie als Schwester hat, hat einen Menschen fürs Leben.",
        "definition_p2": "Manchmal beste Freundin. Manchmal größter Nervtöter. Immer Familie.",
        "synonyme": "Komplizin · Vertraute · Familie"
      },
      {
        "title": "Komplizin fürs Leben",
        "hauptwort": "Schwester",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Mit ihr teilt man Geheimnisse, Erinnerungen und manchmal auch den letzten Schluck. Sie versteht Sätze, die nie gesagt werden müssen, und Blicke, für die andere Worte brauchen.",
        "definition_p2": "Eine Schwester ist die erste Freundin, die man je hatte.",
        "synonyme": "Verbündete · Seelenverwandte · Anker"
      },
      {
        "title": "Vertraute",
        "hauptwort": "Schwester",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Bei ihr darf alles gesagt werden - und das meiste auch zweimal. Sie hört zu, ohne zu werten. Sie kennt einen mit allen Macken und liebt einen trotzdem. Oder vielleicht genau deshalb.",
        "definition_p2": "Manche Geheimnisse gehören nur in ein Paar Ohren.",
        "synonyme": "Zuhörerin · Halt · Schutzraum"
      }
    ],
    "bruder": [
      {
        "title": "Bester Bruder",
        "hauptwort": "Bruder",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er war der erste Spielkamerad, der erste Streitpartner und der erste, der zur Stelle ist, wenn es ernst wird. Mit ihm hat man die Welt erobert, lange bevor sie groß war. Was zwischen Brüdern ist, ist mit nichts zu vergleichen.",
        "definition_p2": "Bruder ist mehr als ein Wort. Es ist ein Versprechen.",
        "synonyme": "Verbündeter · Freund · Familie"
      },
      {
        "title": "Held der Kindheit",
        "hauptwort": "Bruder",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Vorbild, Mitkämpfer, Maßstab. Er ging die Wege voraus, auf denen man später selbst gestolpert ist - und wartete am Ende, um einen wieder hochzuziehen. Halb Idol, halb Anstifter.",
        "definition_p2": "Ohne ihn wäre die Kindheit nur halb so wild gewesen.",
        "synonyme": "Vorbild · Anführer · Beschützer"
      },
      {
        "title": "Beschützer",
        "hauptwort": "Bruder",
        "phonetik": "[Name] Substantiv, männlich",
        "definition_p1": "Er ist da, wenn es eng wird. Ohne Nachfragen, ohne Bedingungen. Er muss nicht laut sein, um etwas zu klären - seine bloße Anwesenheit reicht oft schon. Auf ihn ist Verlass, immer.",
        "definition_p2": "Manche Familienmitglieder sind auch ein Schutzschild.",
        "synonyme": "Schutz · Verlass · Rückhalt"
      }
    ],
    "familie": [
      {
        "title": "Zuhause",
        "hauptwort": "Familie",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Familie ist nicht nur ein Ort - sie ist ein Gefühl. Es sind die Menschen, zu denen man immer zurückkommt, egal wie weit man geht. Es sind die Stimmen, die einen am Tisch erwarten, und die Hände, die einen festhalten, wenn alles wankt.",
        "definition_p2": "Zuhause ist da, wo Familie ist.",
        "synonyme": "Heimat · Geborgenheit · Wurzeln"
      },
      {
        "title": "Anker",
        "hauptwort": "Familie",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Wenn die Welt unruhig wird, halten sie einen am Boden. Sie teilen Sorgen, ohne dass man fragen muss. Sie feiern Erfolge, als wären es ihre eigenen. Eine Familie macht aus Stürmen eine Geschichte, die man später zusammen erzählt.",
        "definition_p2": "Solange sie da sind, geht man nicht verloren.",
        "synonyme": "Halt · Rückhalt · Fundament"
      },
      {
        "title": "Halt",
        "hauptwort": "Familie",
        "phonetik": "[Name] Substantiv, weiblich",
        "definition_p1": "Sie sieht einen so, wie man wirklich ist - und bleibt trotzdem. Sie ist die Konstante, wenn alles andere sich ändert. Bei ihr muss man sich nicht erklären, nicht beweisen, nicht verstellen.",
        "definition_p2": "Familie ist das Netz, das immer da ist. Ob man es braucht oder nicht.",
        "synonyme": "Sicherheit · Verlass · Liebe"
      }
    ]
  }
}
;
// ===== state.js =====
/* Reaktiver State + Subscriber-Pattern.
 * Andere Module rufen setState({...}) auf, alle Subscriber bekommen den
 * neuen State. render.js abonniert und schreibt Werte in die DOM. */

const state = {
  // Layout-Tab
  photo_url: null,             // gecroppte DataURL (was im Poster gezeigt wird)
  photo_url_original: null,    // ungecroppte DataURL (fuer "Neu zuschneiden")
  photo_crop: null,
  /* Original-Pixel-Dimensionen des Uploads (vor Resize) — fuer DPI-Berechnung.
   * Cropper sieht eine 2400px-downscaled Variante; fuer Quality-Anzeige
   * brauchen wir die echten Original-Dimensionen. */
  natural_width: 0,
  natural_height: 0,
  /* Crop-Verhältnisse 0-1 vom Cropper.js (cropped px / source px) */
  crop_width: 1,
  crop_height: 1,
  passepartout: 'white',
  filter: 'original',
  // Text-Tab — Defaults aus Section-Settings (window.DEFINITION_DEFAULTS),
  // damit pro Anlass (Mama / Papa / Oma / etc) andere Werte greifen.
  // Section-Liquid setzt window.DEFINITION_DEFAULTS aus den Settings.
  hauptwort: (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.hauptwort) || 'Mama',
  hauptwort_font: "'clother', sans-serif",  // Style: Modern (default) / Elegant / Verspielt
  hauptwort_font_weight: 700,                // Parlare hat nur 400 — sonst syntetisches Bold = kaputte Glyphen
  phonetik: (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.phonetik) || '[Anna] Substantiv, weiblich',
  definition: (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.definition) || 'Sie liebt ohne Bedingung, kämpft ohne zu zögern und gibt, ohne je zu fragen, was zurückkommt. Mit Mut, Wärme und einem unerschütterlichen Willen meistert sie jeden Tag - und macht ihn für die Menschen um sie herum besser.\n\nSie ist nicht nur Mutter. Sie ist Heldin, Halt und Vorbild zugleich.',
  /* Schlagwort-Title aus dem Inspirations-Template — wird im Cart als
   * "Definition: Powermama" gezeigt statt des langen Volltexts.
   * Wird auf '' gesetzt wenn User die Definition manuell editiert. */
  definition_title: (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.definition_title) || 'Powermama',
  synonyme: (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.synonyme) || 'Powerfrau · Kämpferin · Heldin',
  // Produkt-Tab
  size: '30x40',
  frame_color: 'none',   /* default = type 1 (Mattes Poster) hat keinen Rahmen */
  // Cart-Add Felder
  variant_id: null,                 /* numerische Shopify-Variant-ID, vom DOM gelesen */
  product_type: 'Mattes Poster',    /* 'Mattes Poster' | 'Poster im Holzrahmen' | 'Metal Poster' */
  price: '29,90',                   /* Default Mattes 30x40, wird beim Size/Type-Click ueberschrieben */
  user_image_url: null,             /* S3-URL des Original-Uploads, fuer Server-Print-Render */
  crop_x: 0,
  crop_y: 0,
  /* crop_width + crop_height existieren bereits oben — 0..1 Ratios des Cropper-Outputs */
};

const subscribers = [];

function subscribe(fn) {
  subscribers.push(fn);
}

function setState(updates) {
  Object.assign(state, updates);
  subscribers.forEach(fn => fn(state));
}


// ===== render.js =====
/* Reaktives Rendering — abonniert state.js und schreibt alle Werte in die DOM.
 * Wird einmal beim Load gerendert + bei jedem setState({...}). */


const $renderArea = document.querySelector('.render-area');
const $photo = document.querySelector('.poster-photo');
const $placeholder = document.querySelector('.poster-photo__placeholder');
const $hauptwort = document.querySelector('.poster-text__hauptwort');
const $phonetik = document.querySelector('.poster-text__phonetik');
const $textBlock = document.querySelector('.poster-text');

function render(s) {
  // Data-attributes auf der Render-Area triggern CSS (passepartout/frame)
  $renderArea.dataset.passepartout = s.passepartout;
  $renderArea.dataset.frameColor = s.frame_color;
  // Filter sitzt auf .poster-photo (CSS-Selektor in filters.css)
  $photo.dataset.filter = s.filter;

  // Foto: real-upload als <img.poster-photo__real>, vorher mockup (.poster-photo__mockup
  // im Liquid bereits geladen). Mockup wird per display geschaltet damit kein
  // Reload des Files passiert beim Toggle.
  // Plus: .has-photo class steuert Hover-CTA-Visibility (CSS).
  const $mockup = $photo.querySelector('.poster-photo__mockup');
  if (s.photo_url) {
    let img = $photo.querySelector('img.poster-photo__real');
    if (!img) {
      img = document.createElement('img');
      img.className = 'poster-photo__real';
      img.alt = '';
      $photo.appendChild(img);
    }
    img.src = s.photo_url;
    if ($mockup) $mockup.style.display = 'none';
    if ($placeholder) $placeholder.style.display = 'none';
    $photo.classList.add('has-photo');
  } else {
    const img = $photo.querySelector('img.poster-photo__real');
    if (img) img.remove();
    if ($mockup) $mockup.style.display = '';
    if ($placeholder) $placeholder.style.display = 'none';
    $photo.classList.remove('has-photo');
  }

  // Text-Slots
  $hauptwort.textContent = s.hauptwort;
  $hauptwort.style.fontFamily = s.hauptwort_font;
  $hauptwort.style.fontWeight = s.hauptwort_font_weight;
  $phonetik.textContent = s.phonetik;

  // Definition (line-breaks vom User-Textarea als <p>-Trenner) + Synonyme dynamisch
  const existingPs = $textBlock.querySelectorAll('.poster-text__definition, .poster-text__synonyme');
  existingPs.forEach(p => p.remove());

  if (s.definition) {
    // \n\n trennt Paragraphen, einzelne \n innerhalb bleiben als <br>
    s.definition.split(/\n{2,}/).forEach(paragraph => {
      const trimmed = paragraph.trim();
      if (!trimmed) return;
      const p = document.createElement('p');
      p.className = 'poster-text__definition';
      trimmed.split('\n').forEach((line, i) => {
        if (i > 0) p.appendChild(document.createElement('br'));
        p.appendChild(document.createTextNode(line));
      });
      $textBlock.appendChild(p);
    });
  }
  if (s.synonyme) {
    const syn = document.createElement('p');
    syn.className = 'poster-text__synonyme';
    syn.innerHTML = `<em>Synonyme:</em> ${s.synonyme}`;
    $textBlock.appendChild(syn);
  }
}

subscribe(render);
render(state); // Initial-Render

/* Tab-Hilfe (Light-Bulb-Toggle) — Pattern aus citymap.js/photo.js.
 * Click auf .tab-help__toggle blendet das nächste .tab-help__content ein,
 * Click auf .tab-help__close blendet wieder aus. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tab-help__toggle').forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault();
      const help = toggle.closest('.tab-help');
      if (!help) return;
      const content = help.nextElementSibling;
      if (!content || !content.classList.contains('tab-help__content')) return;
      const isOpen = content.style.display !== 'none';
      content.style.display = isOpen ? 'none' : '';
      toggle.classList.toggle('is-active', !isOpen);
    });
  });
  document.querySelectorAll('.tab-help__close a').forEach(closeBtn => {
    closeBtn.addEventListener('click', e => {
      e.preventDefault();
      const content = closeBtn.closest('.tab-help__content');
      if (!content) return;
      content.style.display = 'none';
      const help = content.previousElementSibling;
      const toggle = help && help.querySelector('.tab-help__toggle');
      if (toggle) toggle.classList.remove('is-active');
    });
  });
});

/* Click auf .poster-photo (im Render-Frame) -> File-Picker direkt oeffnen.
 * Spart dem User den Tab-Wechsel zum Layout-Tab "Dein Foto"-Section.
 * Pattern wie Desenio/Momenterie. */
document.addEventListener('DOMContentLoaded', () => {
  const $clickPhoto = document.getElementById('poster-photo-clickable');
  if ($clickPhoto) {
    $clickPhoto.addEventListener('click', () => {
      const fileInput = document.getElementById('photo-file-input');
      if (fileInput) fileInput.click();
    });
  }
});


// ===== photo-upload.js =====
/* T4: Foto-Upload mit Cropper.js
 *
 * Pattern-Vorbild: distantlines/assets/photo.js (Stadt-/Sternkarten/Foto-Editor).
 * Hier vereinfacht fuer Standalone-Static-Site:
 *   - Kein S3-Upload, kein Server-Print (Preview-Only).
 *   - Kein HEIC-Decode-Pfad — Browser handelt's via accept best-effort.
 *   - Crop-Modal-Aspect wird live aus .poster-photo gemessen statt hartkodiert,
 *     analog zu photo.js Z. 639–646 (CSS-Padding-Quirk + flex-Ratio sind
 *     instabil in Math, DOM ist Source of Truth).
 *   - 2400px Pre-Resize VOR Cropper-Init verhindert OOM bei 24-MP Smartphone-
 *     Fotos (Memory: project_photo_resize_before_cropper.md).
 *
 * State-Integration: setState({ photo_url }) -> render.js zeigt das Foto in
 * .poster-photo > img an.
 */


const ACCEPT_MIME = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];
const MAX_SIDE_PX = 2400;

let cropperInstance = null;
/* V9.96.28j: initial ratio fuer Zoom-Slider-Sync + Hard-Cap (1:1 Fotoposter) */
let initialCropperRatio = null;
let pendingFileName = null;

// -------------------------------------------------------------------
// DOM-Refs (lazy — nach DOMContentLoaded gesetzt)
// -------------------------------------------------------------------
let uploadZone, fileInput, changeRow, nameDisplay, uploadStatus,
    cropperBackdrop, cropperImage, applyBtn, cancelBtn;

// -------------------------------------------------------------------
// Upload-Status (Bild wird hochgeladen…) mit Progress-Bar
// -------------------------------------------------------------------
function showUploadStatus(state, label, pct) {
  if (!uploadStatus) return;
  uploadStatus.className = 'photo-upload-status is-' + state;
  if (state === 'uploading') {
    const safePct = Math.max(0, Math.min(100, Math.round(pct || 0)));
    uploadStatus.innerHTML =
      '<div>' + label + ' ' + safePct + '%</div>' +
      '<span class="progress-bar"><span class="progress-bar-fill" style="width:' + safePct + '%"></span></span>';
  } else {
    uploadStatus.textContent = label;
  }
}
function hideUploadStatus() {
  if (!uploadStatus) return;
  uploadStatus.className = 'photo-upload-status';
  uploadStatus.innerHTML = '';
}

// -------------------------------------------------------------------
// Pre-Cropper Resize: schrumpft DataURL auf max. MAX_SIDE_PX Long-Side.
// Verhindert Renderer-Crash (Chrome OOM) bei grossen Smartphone-Fotos.
// -------------------------------------------------------------------
function resizeDataUrlIfTooLarge(dataUrl, maxSide) {
  /* Returnt { dataUrl, originalWidth, originalHeight } — Original-Dimensionen
   * werden gemerkt, damit DPI-Quality-Calc auf den echten Pixeln basiert
   * (nicht auf der downscaled 2400px-Variante). */
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      if (w <= maxSide && h <= maxSide) {
        resolve({ dataUrl, originalWidth: w, originalHeight: h });
        return;
      }
      const scale = maxSide / Math.max(w, h);
      const sw = Math.round(w * scale);
      const sh = Math.round(h * scale);
      const canvas = document.createElement('canvas');
      canvas.width = sw;
      canvas.height = sh;
      canvas.getContext('2d').drawImage(img, 0, 0, sw, sh);
      resolve({
        dataUrl: canvas.toDataURL('image/jpeg', 0.9),
        originalWidth: w,
        originalHeight: h,
      });
    };
    img.onerror = () => reject(new Error('image decode failed'));
    img.src = dataUrl;
  });
}

// -------------------------------------------------------------------
// S3-Upload via presigned URL — Pattern 1:1 aus photo.js (Z. 730-818).
// Liefert eine Promise<string> mit der publicUrl. Schlaegt fehl wenn der
// Backend-Endpoint nicht erreichbar ist; Caller faengt das ab.
// -------------------------------------------------------------------
function uploadFileToS3(file) {
  const apiUrl = window.DEFINITION_BACKEND_API_URL || 'https://tiles.distantlines.de';
  return fetch(apiUrl + '/api/v1/upload/presigned-url/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      file_name: file.name,
      content_type: file.type || 'application/octet-stream',
    }),
  })
  .then(r => {
    if (!r.ok) throw new Error('Presigned-URL HTTP ' + r.status);
    return r.json();
  })
  .then(data => {
    const uploadUrl = data.uploadUrl || data.upload_url || data.presigned_url;
    const publicUrl = data.publicUrl || data.public_url || data.file_url || data.url;
    const fields = data.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Presigned-Response ungueltig');
    const fd = new FormData();
    Object.keys(fields).forEach(k => fd.append(k, fields[k]));
    fd.append('file', file);
    return fetch(uploadUrl, { method: 'POST', body: fd })
      .then(s3Res => {
        if (!s3Res.ok) throw new Error('S3-Upload HTTP ' + s3Res.status);
        return publicUrl;
      });
  });
}

// -------------------------------------------------------------------
// Aspect-Ratio aus dem DOM messen — exakt wie photo.js Z. 639.
// Editor und Crop muessen 1:1 sein, sonst clipt object-fit:cover spaeter.
// -------------------------------------------------------------------
function measureCropAspect() {
  const el = document.querySelector('.poster-photo');
  if (!el) return 5 / 4; // sicherer Fallback ~Landscape
  const rect = el.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return 5 / 4;
  return rect.width / rect.height;
}

// -------------------------------------------------------------------
// Upload-UI-State: zwischen Dropzone und "Foto-Name + Buttons" wechseln.
// -------------------------------------------------------------------
function showUploadedState(filename) {
  uploadZone.style.display = 'none';
  const hint = document.querySelector('.photo-upload-hint');
  if (hint) hint.style.display = 'none';
  changeRow.classList.add('visible');
  if (nameDisplay) nameDisplay.textContent = filename || 'Foto.jpg';
  /* Qualitäts-Btn wird von quality.js gesteuert — basiert auf natural_width/-height */
}

function showInitialState() {
  uploadZone.style.display = '';
  const hint = document.querySelector('.photo-upload-hint');
  if (hint) hint.style.display = '';
  changeRow.classList.remove('visible');
  if (nameDisplay) nameDisplay.textContent = '';
}

// -------------------------------------------------------------------
// File-Picking + Drag-Drop
// -------------------------------------------------------------------
function handleFile(file) {
  if (!file) return;

  const isHeic = /\.heic$|\.heif$/i.test(file.name) ||
                 file.type === 'image/heic' || file.type === 'image/heif';

  if (!isHeic && !ACCEPT_MIME.includes(file.type)) {
    alert('Dateityp nicht unterstuetzt. Bitte JPG, PNG oder HEIC.');
    return;
  }

  pendingFileName = file.name;

  /* S3-Upload startet parallel zum FileReader-Resize-Pfad — die public-URL
   * brauchen wir beim Cart-Add fuer den Server-Print-Render. Faellt der
   * Upload aus, bleibt der Editor nutzbar; Cart-Add warnt dann. */
  uploadFileToS3(file)
    .then(url => { setState({ user_image_url: url }); })
    .catch(err => {
      console.warn('[photo-upload] S3-Upload failed:', err);
      // user_image_url bleibt null — addToCart() warnt der Server-Render-
      // Pipeline, dass das Print-Foto nicht verfuegbar ist.
    });

  /* Status anzeigen — FileReader-Progress feedet Live-Pct */
  showUploadStatus('uploading', 'Bild wird hochgeladen…', 0);

  const reader = new FileReader();
  reader.onprogress = (ev) => {
    if (ev.lengthComputable) {
      // FileReader = ~50% des Gesamt-Progress (2. Hälfte ist Resize+Decode)
      const pct = (ev.loaded / ev.total) * 50;
      showUploadStatus('uploading', 'Bild wird hochgeladen…', pct);
    }
  };
  reader.onload = (ev) => {
    showUploadStatus('uploading', 'Bild wird hochgeladen…', 60);
    // Vor Cropper-Init auf max 2400px Long-Side downscalen — sonst killt
    // Chrome den Renderer bei Pan/Zoom auf grossen Fotos (OOM).
    resizeDataUrlIfTooLarge(ev.target.result, MAX_SIDE_PX)
      .then((res) => {
        const { dataUrl, originalWidth, originalHeight } = res;
        showUploadStatus('uploading', 'Bild wird hochgeladen…', 100);
        /* natural_width/_height fuer DPI-Quality-Calc speichern */
        setState({
          photo_url_original: dataUrl,
          natural_width: originalWidth,
          natural_height: originalHeight,
        });
        /* kurz 100% sichtbar lassen, dann verstecken + Cropper-Modal oeffnen */
        setTimeout(() => {
          hideUploadStatus();
          openCropperWithUrl(dataUrl);
        }, 250);
      })
      .catch((err) => {
        console.warn('[photo-upload] resize failed, fallback to original:', err);
        showUploadStatus('error', 'Bild konnte nicht verarbeitet werden.');
        setTimeout(() => {
          hideUploadStatus();
          setState({ photo_url_original: ev.target.result });
          openCropperWithUrl(ev.target.result);
        }, 500);
      });
  };
  reader.onerror = () => {
    showUploadStatus('error', 'Datei konnte nicht gelesen werden.');
    setTimeout(hideUploadStatus, 3000);
  };
  reader.readAsDataURL(file);
}

// -------------------------------------------------------------------
// Cropper Modal
// -------------------------------------------------------------------
function openCropperWithUrl(url) {
  if (typeof Cropper === 'undefined') {
    console.error('[photo-upload] Cropper.js noch nicht geladen');
    alert('Bild-Editor wird noch geladen. Bitte kurz warten.');
    return;
  }

  cropperImage.src = url;
  cropperBackdrop.classList.add('visible');

  if (cropperInstance) {
    try { cropperInstance.destroy(); } catch (e) {}
    cropperInstance = null;
  }

  cropperImage.onload = () => {
    const cropAspect = measureCropAspect();

    // rAF deferren — Modal-Display-Switch ist sync, aber Layout-Reflow
    // kommt erst im naechsten Frame. Sonst misst Cropper.js die alten
    // 0x0-Container-Maße (display:none vorher).
    requestAnimationFrame(() => {
      cropperInstance = new Cropper(cropperImage, {
        aspectRatio: cropAspect,
        viewMode: 1,
        autoCropArea: 1,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        cropBoxResizable: true,
        dragMode: 'none',                 // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08., wie Fotoposter)
        toggleDragModeOnDblclick: false,
        minCropBoxWidth: 60,
        minCropBoxHeight: 60,
        responsive: false,
        background: false,
        modal: true,         // dunkler Overlay aussserhalb der Crop-Box (wie Fotoposter)
        wheelZoomRatio: 0.08,
        /* V9.96.28j: Zoom-Slider-Sync + Hard-Cap 100-200% (1:1 Fotoposter Z707-741) */
        ready: function () {
          const cd = cropperInstance.getCanvasData();
          initialCropperRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
          const slider = document.getElementById('photo-cropper-zoom-slider');
          if (slider) slider.value = 100;
          requestAnimationFrame(function () {
            if (cropperInstance && typeof cropperInstance.resize === 'function') {
              try { cropperInstance.resize(); } catch (e) {}
            }
          });
        },
        zoom: function (ev) {
          if (!initialCropperRatio) return;
          const minRatio = initialCropperRatio;
          const maxRatio = initialCropperRatio * 2;
          if (ev.detail.ratio < minRatio || ev.detail.ratio > maxRatio) {
            ev.preventDefault();
            return;
          }
          const slider = document.getElementById('photo-cropper-zoom-slider');
          if (!slider) return;
          const pct = Math.round((ev.detail.ratio / initialCropperRatio) * 100);
          slider.value = Math.max(100, Math.min(200, pct));
        },
      });
    });
  };
}

/* V9.96.28j: Zoom-Slider + Plus/Minus-Buttons — einmalig binden (analog Fotoposter Z612-627) */
(function initCropperZoomBar() {
  const zoomSlider = document.getElementById('photo-cropper-zoom-slider');
  if (zoomSlider) {
    zoomSlider.addEventListener('input', function () {
      if (!cropperInstance || !initialCropperRatio) return;
      const factor = parseInt(this.value, 10) / 100;
      cropperInstance.zoomTo(initialCropperRatio * factor);
    });
  }
  const zoomInBtn = document.getElementById('photo-cropper-zoom-in');
  if (zoomInBtn) zoomInBtn.addEventListener('click', function () {
    if (cropperInstance) cropperInstance.zoom(0.1);
  });
  const zoomOutBtn = document.getElementById('photo-cropper-zoom-out');
  if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () {
    if (cropperInstance) cropperInstance.zoom(-0.1);
  });
})();

function closeCropperModal() {
  cropperBackdrop.classList.remove('visible');
  if (cropperInstance) {
    try { cropperInstance.destroy(); } catch (e) {}
    cropperInstance = null;
  }
  cropperImage.src = '';
  // File-Input zuruecksetzen damit dasselbe File erneut waehlbar bleibt
  if (fileInput) fileInput.value = '';
}

function applyCrop() {
  if (!cropperInstance) return;

  try {
    const canvas = cropperInstance.getCroppedCanvas({
      maxWidth: 2400,
      maxHeight: 2400,
      fillColor: '#ffffff',
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high',
    });
    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

    /* Crop-Ratios (0..1) fuer DPI-Quality-Calc UND Server-Render-Pipeline:
     * cropped px / source px. Cropper sieht eine 2400px-downscaled Variante;
     * das Ratio ist invariant gegen Downscaling, gilt also auch fuer das
     * Original (S3-Upload). Server nutzt S3-Original + crop_x/y/w/h fuer
     * den Print-Render — Pattern wie photo.js Z. 502. */
    const cropData = cropperInstance.getData(true); // rounded ints
    const imageData = cropperInstance.getImageData();
    const sourceW = imageData.naturalWidth || 1;
    const sourceH = imageData.naturalHeight || 1;
    const cropX = Math.min(1, Math.max(0, (cropData.x || 0) / sourceW));
    const cropY = Math.min(1, Math.max(0, (cropData.y || 0) / sourceH));
    const cropW = Math.min(1, Math.max(0, (cropData.width || sourceW) / sourceW));
    const cropH = Math.min(1, Math.max(0, (cropData.height || sourceH) / sourceH));

    setState({
      photo_url: dataUrl,
      crop_x: cropX,
      crop_y: cropY,
      crop_width: cropW,
      crop_height: cropH,
    });
    showUploadedState(pendingFileName);
  } catch (err) {
    console.error('[photo-upload] getCroppedCanvas failed:', err);
    alert('Foto konnte nicht zugeschnitten werden.');
  }

  closeCropperModal();
}

// -------------------------------------------------------------------
// Init — DOMContentLoaded handler
// -------------------------------------------------------------------
// WICHTIG: Funktion heisst initPhotoUpload (nicht init), weil inspirations.js
// im selben IIFE-Scope auch ein function init() deklariert. JS-Hoisting laesst
// die spaetere Declaration gewinnen → sonst rief dieser File die inspirations-
// init() statt seiner eigenen auf, photo-upload-Listener wurden NIE registriert.
function initPhotoUpload() {
  uploadZone = document.getElementById('photo-upload-zone');
  fileInput = document.getElementById('photo-file-input');
  changeRow = document.getElementById('photo-change-row');
  nameDisplay = document.getElementById('photo-name-display');
  uploadStatus = document.getElementById('photo-upload-status');
  cropperBackdrop = document.getElementById('photo-cropper-backdrop');
  cropperImage = document.getElementById('photo-cropper-image');
  applyBtn = document.getElementById('photo-cropper-apply');
  cancelBtn = document.getElementById('photo-cropper-cancel');

  if (!uploadZone || !fileInput || !cropperBackdrop || !cropperImage) {
    console.warn('[photo-upload] required DOM nodes missing — skipping init');
    return;
  }

  // Click auf Zone -> File-Picker (label-Element triggert das eh, aber
  // wir lassen es defensiv stehen falls jemand das label durch div ersetzt)
  fileInput.addEventListener('change', (e) => {
    const file = e.target.files && e.target.files[0];
    handleFile(file);
  });

  // Drag-Drop
  ['dragenter', 'dragover'].forEach(evt => {
    uploadZone.addEventListener(evt, (e) => {
      e.preventDefault();
      e.stopPropagation();
      uploadZone.classList.add('drag-over');
    });
  });
  ['dragleave', 'drop'].forEach(evt => {
    uploadZone.addEventListener(evt, (e) => {
      e.preventDefault();
      e.stopPropagation();
      uploadZone.classList.remove('drag-over');
    });
  });
  uploadZone.addEventListener('drop', (e) => {
    const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    handleFile(file);
  });

  // "Neu zuschneiden" -> Modal mit ORIGINAL-DataURL wieder oeffnen
  // (nicht der bereits gecroppten Variante, sonst kann der User nur
  // weiter reinzoomen, nicht wieder rauszoomen).
  const recropBtn = document.getElementById('photo-recrop-btn');
  if (recropBtn) {
    recropBtn.addEventListener('click', () => {
      const original = state.photo_url_original;
      if (original) {
        openCropperWithUrl(original);
      } else {
        // Fallback: was als <img> in der Render-Area liegt
        const img = document.querySelector('.poster-photo img');
        if (img && img.src) openCropperWithUrl(img.src);
      }
    });
  }

  // "Anderes Foto" -> Datei-Picker erneut oeffnen
  const changeBtn = document.getElementById('photo-change-btn');
  if (changeBtn) {
    changeBtn.addEventListener('click', () => {
      fileInput.click();
    });
  }

  // Modal-Buttons
  applyBtn.addEventListener('click', applyCrop);
  cancelBtn.addEventListener('click', () => {
    closeCropperModal();
    pendingFileName = null;
  });

  // Drag-aware Backdrop-Close: nur schliessen wenn pointerdown UND pointerup
  // auf dem Backdrop selbst stattfanden — sonst frisst ein Drag aus der
  // Crop-Box raus den click und schliesst das Modal ungewollt
  // (photo.js Z. 561–583 Pattern).
  let backdropArmed = false;
  cropperBackdrop.addEventListener('pointerdown', (e) => {
    backdropArmed = (e.target === cropperBackdrop);
  });
  cropperBackdrop.addEventListener('pointerup', (e) => {
    const shouldClose = backdropArmed && e.target === cropperBackdrop;
    backdropArmed = false;
    if (shouldClose) {
      closeCropperModal();
      pendingFileName = null;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhotoUpload);
} else {
  initPhotoUpload();
}


// ===== produkt.js =====
/* Produkt-Tab — Type-Picker (3 el__format-Blöcke) + Size-Picker per Block
 * + Frame-Picker (nur in el__format[2] = Holzrahmen) + Live-Preis. */

/* Aspect-Ratio (long/short) pro Druckformat */
const SIZE_RATIOS = {
  '30x40': 40 / 30,
  '40x50': 50 / 40,
  '50x70': 70 / 50,
  '70x100': 100 / 70,
};

const $frame = document.querySelector('.poster-frame');
const $priceDisplay = document.getElementById('variant-price');

function applySize(size) {
  const ratio = SIZE_RATIOS[size];
  if (ratio && $frame) {
    $frame.style.setProperty('--poster-ratio', String(ratio));
  }
}

function updatePriceDisplay(priceStr) {
  /* V9.96.28e: Format "XX,XX €" (Symbol hinter Zahl, analog Citymap V9.96.5)
   * V9.96.28h: data-price ist money_without_currency "39,90" — Komma->Punkt vor parseFloat
   * sonst stoppt parseFloat am Komma und verliert die Cents. */
  const price = parseFloat(String(priceStr).replace(',', '.'));
  if ($priceDisplay && !isNaN(price)) {
    $priceDisplay.textContent = price.toFixed(2).replace('.', ',') + ' €';
  }
}

/* Type-Picker: 3 el__format-Blöcke umschalten + Frame-Visibility koppeln */
const $typeLinks = document.querySelectorAll('#type-picker > li > a');
const $formats = document.querySelectorAll('.produkt__wrapper .el__format');

/* Letzte Frame-Farb-Wahl merken — Default Schwarz, wird beim Frame-Picker-Click
 * aktualisiert. Beim Wechsel auf type=2 wird dieser Wert wieder appliziert. */
let lastFrameColorChoice = 'black';

$typeLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    $typeLinks.forEach(l => l.classList.toggle('current', l === link));
    const id = link.dataset.id;
    const productType = link.dataset.type;  /* "Mattes Poster" / "Poster im Holzrahmen" / "Metal Poster" */
    $formats.forEach(f => {
      f.style.display = (f.dataset.id === id) ? '' : 'none';
    });
    /* V9.96.28d: editor-benefits-wrapper pro Type toggeln (analog Citymap/Stern) */
    document.querySelectorAll('.definition-customizer .editor-benefits-wrapper').forEach(wrap => {
      wrap.style.display = (wrap.dataset.id === id) ? 'block' : 'none';
    });
    /* Frame-Visibility: nur Type 2 (Holzrahmen) zeigt Rahmen.
     * Type 1 (Mattes Poster) und Type 3 (Metall) -> 'none' */
    const newFrame = (id === '2') ? lastFrameColorChoice : 'none';
    /* Beim Type-Wechsel: aktive Größe im neuen el__format auslesen + Preis + variant_id */
    const activeFormat = document.querySelector('.produkt__wrapper .el__format[data-id="' + id + '"]');
    if (activeFormat) {
      const activeSize = activeFormat.querySelector('.size__picker a.current');
      if (activeSize) {
        applySize(activeSize.dataset.size);
        updatePriceDisplay(activeSize.dataset.price);
        setState({
          size: activeSize.dataset.size,
          frame_color: newFrame,
          product_type: productType,
          variant_id: parseInt(activeSize.dataset.variantId, 10),
          price: activeSize.dataset.price,
        });
      } else {
        setState({ frame_color: newFrame, product_type: productType });
      }
    } else {
      setState({ frame_color: newFrame, product_type: productType });
    }
  });
});

/* Größen-Picker: scoped per el__format — nur das aktive el__format hat sichtbare Größen */
document.querySelectorAll('.size__picker').forEach(picker => {
  const $sizeLinks = picker.querySelectorAll(':scope a');
  $sizeLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      $sizeLinks.forEach(l => l.classList.toggle('current', l === link));
      const size = link.dataset.size;
      applySize(size);
      updatePriceDisplay(link.dataset.price);
      setState({
        size: size,
        variant_id: parseInt(link.dataset.variantId, 10),
        price: link.dataset.price,
      });
    });
  });
});

/* Frame-Picker (nur in el__format[2] = Holzrahmen sichtbar) — speichert
 * lastFrameColorChoice damit Type-Wechsel auf 2 zurueck die letzte Wahl reaktiviert.
 * variant_id ist size-bound (option1=Produkt, option2=Groesse), Frame-Color
 * ist Cart-Property — daher kein variant_id-Update hier. */
const $frameLinks = document.querySelectorAll('#frame-picker > li > a');
$frameLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    $frameLinks.forEach(l => l.classList.toggle('current', l === link));
    lastFrameColorChoice = link.dataset.frameColor;
    setState({ frame_color: lastFrameColorChoice });
  });
});

/* Default-Variant aus DOM lesen — Type 1 (Mattes), erste Size mit .current.
 * Damit Cart-Add ohne vorheriges Type-/Size-Wechsel sofort eine variant_id hat. */
(function initDefaultVariant() {
  const defaultActiveSize = document.querySelector(
    '.produkt__wrapper .el__format[data-id="1"] .size__picker a.current'
  );
  if (defaultActiveSize && defaultActiveSize.dataset.variantId) {
    setState({
      variant_id: parseInt(defaultActiveSize.dataset.variantId, 10),
      size: defaultActiveSize.dataset.size,
      price: defaultActiveSize.dataset.price,
      product_type: 'Mattes Poster',
    });
  }
})();

/* Cart-Button — Validation 1:1 wie Fotoposter (photo.js:1552-1556): wenn kein
 * Foto hochgeladen, oeffnet ein freundliches Hinweis-Modal (statt alert). */
const $cartBtn = document.getElementById('cart-btn');
const $noticeModal = document.getElementById('cart-no-photo-modal');
const $noticeClose = document.getElementById('cart-no-photo-close');
const $noticeCta = document.getElementById('cart-no-photo-cta');

function openNoticeModal() { if ($noticeModal) $noticeModal.classList.add('visible'); }
function closeNoticeModal() { if ($noticeModal) $noticeModal.classList.remove('visible'); }

/* Cart-Add — Pattern aus photo.js Z. 1647-1718.
 * Properties bauen, /cart/add.js POST, Cart-Drawer-Open + Refresh-Events. */
async function addToCart() {
  if (!state.photo_url) {
    openNoticeModal();
    return;
  }
  if (!state.variant_id) {
    alert('Bitte Größe auswählen.');
    return;
  }
  const originalText = $cartBtn.textContent;
  $cartBtn.textContent = 'Foto wird verarbeitet...';
  $cartBtn.style.pointerEvents = 'none';

  /* ---------------------------------------------------------------
   * Cart-Data-Speicherung (KEIN Render-Trigger hier!).
   * Pattern wie Photo (photo.js Z. 1577 photo_direct_render): Wir
   * speichern nur die Roh-Konfig + variant_id in MamaCartData. Der
   * eigentliche Render passiert ERST beim Order-Webhook (echte
   * Bestellung), sonst rendert der Server fuer jeden Cart-Versuch
   * ein 9 MB PNG das nie gebraucht wird.
   *
   * Returnt cart_token = MamaCartData-UUID. Daraus konstruieren wir
   * deterministisch _print_image_url = /media/mama_renders/<cart_token>.png
   * (Render-Output landet auf demselben Pfad weil MamaRenderJob-ID
   * = cart_token gesetzt wird im Webhook).
   * --------------------------------------------------------------- */
  const renderConfig = {
    user_image_url: state.user_image_url,
    crop_x: state.crop_x, crop_y: state.crop_y,
    crop_width: state.crop_width, crop_height: state.crop_height,
    hauptwort: state.hauptwort,
    hauptwort_font: (state.hauptwort_font || 'clother')
                      .replace(/['"]/g, '')
                      .split(',')[0]
                      .trim(),
    hauptwort_font_weight: state.hauptwort_font_weight,
    phonetik: state.phonetik,
    definition: state.definition,
    definition_title: state.definition_title || '',
    synonyme: state.synonyme,
    passepartout: state.passepartout,
    frame_color: state.frame_color,
    filter: state.filter || 'original',
    paper_size: state.size,
    product_type: state.product_type,
    variant_id: state.variant_id,
  };

  let cartToken = null;
  try {
    const apiUrl = window.DEFINITION_BACKEND_API_URL || 'https://tiles.distantlines.de';
    const cartDataRes = await fetch(apiUrl + '/api/v1/mama/cart-data-endpoint/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(renderConfig),
    });
    if (!cartDataRes.ok) {
      const errText = await cartDataRes.text();
      throw new Error('HTTP ' + cartDataRes.status + ': ' + errText);
    }
    const cartDataResp = await cartDataRes.json();
    cartToken = cartDataResp.cart_token;
    if (!cartToken) throw new Error('Server lieferte keinen cart_token');
  } catch (err) {
    console.error('[mama-cart-data] Speichern fehlgeschlagen:', err);
    alert('Konfiguration konnte nicht gespeichert werden:\n' + (err.message || err) + '\n\nBitte erneut versuchen.');
    $cartBtn.textContent = originalText;
    $cartBtn.style.pointerEvents = '';
    return;
  }

  $cartBtn.textContent = 'Wird hinzugefügt...';

  /* Sichtbar im Cart: nur die 4 inhaltlichen Properties.
   * Definition zeigt nur das Schlagwort (z.B. "Powermama"), nicht den Volltext —
   * sonst sprengt es das Cart-Layout. Voller Definitions-Text liegt in
   * _definition_full fuer den Server-Print-Render.
   * Groesse + Produkt stehen sowieso unter dem Variant-Title, also weglassen.
   * Schrift-Stil/Passepartout/Filter/Rahmenfarbe sind technisch fuer den
   * Print-Server, fuer den User aber Detail-Rauschen — daher _-prefix
   * (Shopify zeigt _-prefixed Properties NICHT im Cart-Display, nur im
   * Order-Backend / Webhook). */
  const properties = {
    '_Hauptwort': state.hauptwort,
    '_Phonetik': state.phonetik,
    '_Synonyme': state.synonyme,
    '_definition_full': state.definition,
    '_schrift_stil': (state.hauptwort_font || '').replace(/['"]/g, ''),
    '_passepartout': state.passepartout,
    '_filter': state.filter || 'original',
    '_groesse': state.size,
    '_produkt': state.product_type,
    '_user_image_url': state.user_image_url || '',
    '_crop_x': String(state.crop_x),
    '_crop_y': String(state.crop_y),
    '_crop_width': String(state.crop_width),
    '_crop_height': String(state.crop_height),
    /* Render-Pipeline: cart_token = MamaCartData-UUID = MamaRenderJob-ID
     * (Webhook erstellt RenderJob mit dieser UUID). _print_image_url
     * deterministisch direkt auf /media/mama_renders/<cart_token>.png —
     * existiert nach Webhook+Worker (~9s nach Order-Erhalt). Bis dahin
     * 404; das ist OK weil Order-Backend bei Druck-Trigger das nachhalt. */
    '_job_id': cartToken,
    '_print_image_url': 'https://tiles.distantlines.de/media/mama_renders/' + cartToken + '.png',
    /* Cart-Vorschau (PROJ-72): persistenter Downscale vom Render-Worker,
     * gleiche Basis wie _print_image_url. */
    '_preview_image_url': 'https://tiles.distantlines.de/media/blanket_renders/' + cartToken + '_cartpreview.jpg',
  };
  /* Definition zeigt das Schlagwort nur wenn Inspirations-Template aktiv —
   * sonst hat der User die Definition selbst editiert und wir lassen das
   * Property weg (sonst stuende ein veraltetes Schlagwort drin). */
  if (state.definition_title) {
    properties['Definition'] = state.definition_title;
  }
  /* Rahmenfarbe nur bei Holzrahmen — Property-Name `_Frame Color` (Capital
   * F+C, mit Space) ist KRITISCH: das Exporteo-Template (exporteo-template-fixed.liquid
   * Z. 88, 165) liest exakt diesen Namen fuer SKU-Mapping zu Posterflow. */
  if (state.frame_color && state.frame_color !== 'none' &&
      state.product_type && state.product_type.indexOf('Holzrahmen') !== -1) {
    properties['_Frame Color'] = state.frame_color;
  }
  /* Leere Werte filtern — sonst blaehen sie die Bestellung auf */
  Object.keys(properties).forEach(k => { if (!properties[k]) delete properties[k]; });

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Sofort-Vorschau (PROJ-72): Schnappschuss der sichtbaren Poster-Vorschau
   * (.poster-frame) in sessionStorage, damit der Cart-Drawer das Motiv sofort
   * zeigt statt auf den Server-Render zu warten. Helper ist fail-soft
   * (2,5s-Notbremse), .catch sichert zusaetzlich ab: der Kauf blockiert nie. */
  const vorschauFertig = (window.kaSofortVorschau
    ? window.kaSofortVorschau($frame, cartToken).catch(() => {})
    : Promise.resolve());
  await vorschauFertig;

  try {
    const cartRes = await fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: state.variant_id, quantity: 1, properties }],
      }),
    });
    if (!cartRes.ok) {
      const text = await cartRes.text();
      throw new Error(text);
    }
    const cartData = await cartRes.json();
    /* GTM dataLayer AddToCart Event */
    if (window.DLTrack && window.DLTrack.addToCart) {
      window.DLTrack.addToCart(cartData);
    }
    /* Cart-Drawer benachrichtigen + oeffnen — Pattern wie photo.js / starmap-celestial.js */
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') {
      cartDrawer.show();
    } else {
      /* Kein Drawer im Theme verfuegbar -> Fallback auf Cart-Page */
      window.location.href = cartRoot + 'cart';
      return;
    }
    $cartBtn.textContent = '✓ Hinzugefügt';
    setTimeout(() => {
      if ($cartBtn) {
        $cartBtn.textContent = originalText;
        $cartBtn.style.pointerEvents = '';
      }
    }, 1800);
  } catch (err) {
    console.error('[cart-add] Fehler:', err);
    alert('Hinzufügen zum Warenkorb fehlgeschlagen: ' + (err.message || 'Unbekannter Fehler'));
    $cartBtn.textContent = originalText;
    $cartBtn.style.pointerEvents = '';
  }
}

if ($cartBtn) {
  $cartBtn.addEventListener('click', e => {
    e.preventDefault();
    addToCart();
  });
}

if ($noticeClose) $noticeClose.addEventListener('click', closeNoticeModal);
if ($noticeModal) {
  $noticeModal.addEventListener('click', e => {
    /* Click auf Backdrop schliesst, aber nicht wenn auf Modal-Card geklickt */
    if (e.target === $noticeModal) closeNoticeModal();
  });
}
if ($noticeCta) {
  $noticeCta.addEventListener('click', e => {
    e.preventDefault();
    closeNoticeModal();
    /* Layout-Tab aktivieren + zur Upload-Zone scrollen */
    const layoutTab = document.querySelector('.main__switcher > ul > li > a[data-tab="layout__wrapper"]');
    if (layoutTab) layoutTab.click();
    setTimeout(() => {
      const zone = document.getElementById('photo-upload-zone');
      if (zone) zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  });
}
/* ESC schliesst das Modal */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && $noticeModal && $noticeModal.classList.contains('visible')) {
    closeNoticeModal();
  }
});


// ===== quality.js =====
/* Qualitäts-Anzeige (DPI-Check) — 1:1 Logik aus distantlines/assets/photo.js
 *
 * Berechnet die effektive Druck-DPI aus dem gecroppten Foto fuer die
 * aktuell gewählte Postergrösse. Setzt data-level (green/orange/red) am
 * .photo-quality-btn + Status-Text + Icon-SVG je Level.
 *
 * Schwellen (1:1): green >= 100 DPI, orange >= 75 DPI, sonst red.
 */

const QUALITY_THRESHOLDS = { green: 100, orange: 75 };
const STATUS_LABELS = { green: 'Ausgezeichnet', orange: 'Akzeptabel', red: 'Niedrig' };
const ICONS = {
  green:  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7.5l3 3 5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  orange: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  red:    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3.5 3.5l7 7M10.5 3.5l-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
};

/* "30x40" -> { w: 30, h: 40 } in cm */
function parseSize(sizeStr) {
  if (!sizeStr) return null;
  const m = String(sizeStr).match(/(\d+)x(\d+)/);
  if (!m) return null;
  return { w: parseInt(m[1], 10), h: parseInt(m[2], 10) };
}

/* DPI-Berechnung: cropped natural px / (paper cm / 2.54) */
function computeQuality(s) {
  if (!s.natural_width || !s.natural_height || !s.photo_url) return null;
  const dim = parseSize(s.size);
  if (!dim) return null;
  const cropW = s.crop_width || 1;
  const cropH = s.crop_height || 1;
  const croppedPxW = s.natural_width * cropW;
  const croppedPxH = s.natural_height * cropH;
  const dpiW = croppedPxW / (dim.w / 2.54);
  const dpiH = croppedPxH / (dim.h / 2.54);
  const dpi = Math.min(dpiW, dpiH);
  let level;
  if (dpi >= QUALITY_THRESHOLDS.green)       level = 'green';
  else if (dpi >= QUALITY_THRESHOLDS.orange) level = 'orange';
  else                                        level = 'red';
  return { level, dpi: Math.round(dpi) };
}

function update(s) {
  const $btn = document.getElementById('photo-quality-btn');
  if (!$btn) return;
  if (!s.photo_url || !s.natural_width) {
    $btn.style.display = 'none';
    return;
  }
  const result = computeQuality(s);
  if (!result) return;
  $btn.style.display = 'flex';
  $btn.setAttribute('data-level', result.level);
  const $status = $btn.querySelector('.quality-status');
  if ($status) $status.textContent = STATUS_LABELS[result.level] || '';
  const $icon = $btn.querySelector('.quality-icon');
  if ($icon) $icon.innerHTML = ICONS[result.level] || ICONS.green;
}

subscribe(update);
update(state);

/* =====================================================================
 * Modal — Click auf Quality-Btn öffnet, listet alle Größen mit Status
 * ===================================================================== */
const QUALITY_CHECK_SIZES = [
  { label: '30x40 cm',  w: 30, h: 40 },
  { label: '40x50 cm',  w: 40, h: 50 },
  { label: '50x70 cm',  w: 50, h: 70 },
  { label: '70x100 cm', w: 70, h: 100 },
];

function renderModalList() {
  const $list = document.getElementById('photo-quality-size-list');
  if (!$list) return;
  $list.innerHTML = '';
  QUALITY_CHECK_SIZES.forEach(size => {
    const sizeKey = size.w + 'x' + size.h;
    const result = computeQuality({ ...state, size: sizeKey });
    if (!result) return;
    const li = document.createElement('li');
    const icon = document.createElement('span');
    icon.className = 'quality-icon';
    icon.setAttribute('data-level', result.level);
    icon.innerHTML = ICONS[result.level] || ICONS.green;
    const labelSpan = document.createElement('span');
    labelSpan.textContent = size.label;
    /* DPI-Zahl bewusst nicht angezeigt — Kunde soll Status (Icon-Farbe)
     * sehen, nicht die exakte DPI-Zahl. Logik+Schwellen bleiben gleich. */
    li.appendChild(icon);
    li.appendChild(labelSpan);
    $list.appendChild(li);
  });
}

const $modal = document.getElementById('photo-quality-modal');
const $btn = document.getElementById('photo-quality-btn');
const $modalClose = document.getElementById('photo-quality-modal-close');

if ($btn) {
  $btn.addEventListener('click', e => {
    e.preventDefault();
    if (!state.photo_url) return;
    renderModalList();
    if ($modal) $modal.classList.add('visible');
  });
}
if ($modalClose) {
  $modalClose.addEventListener('click', e => {
    e.preventDefault();
    if ($modal) $modal.classList.remove('visible');
  });
}
if ($modal) {
  $modal.addEventListener('click', e => {
    if (e.target === $modal) $modal.classList.remove('visible');
  });
}
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && $modal) $modal.classList.remove('visible');
});


// ===== text-inputs.js =====
/* Text-Tab Inputs — bidirektionale Bindung an state.js.
 * Initial werden Felder aus state gefuellt; Input-Events schreiben zurueck. */

const fields = {
  'input-hauptwort':   'hauptwort',
  'input-phonetik':    'phonetik',
  'input-definition':  'definition',
  'input-synonyme':    'synonyme',
};

Object.entries(fields).forEach(([id, key]) => {
  const $el = document.getElementById(id);
  if (!$el) return;
  $el.value = state[key] || '';
  $el.addEventListener('input', () => {
    /* Definition: max 2 consecutive newlines erlauben (User-Wunsch).
     * Drei oder mehr \n -> auf \n\n cappen. */
    if (key === 'definition' && /\n{3,}/.test($el.value)) {
      const cursor = $el.selectionStart;
      $el.value = $el.value.replace(/\n{3,}/g, '\n\n');
      $el.setSelectionRange(cursor, cursor);
    }
    /* User editiert Definition manuell -> Schlagwort-Title clearen
     * damit im Cart kein falscher Title angezeigt wird. */
    if (key === 'definition') {
      setState({ [key]: $el.value, definition_title: '' });
    } else {
      setState({ [key]: $el.value });
    }
  });
});

/* Wenn Inspirations-Klick state aendert, Felder synchronisieren. */
subscribe(s => {
  Object.entries(fields).forEach(([id, key]) => {
    const $el = document.getElementById(id);
    if ($el && $el.value !== s[key]) $el.value = s[key] || '';
  });
});

/* Hauptwort-Style-Buttons (Modern / Elegant / Verspielt) — Klick wechselt
 * `state.hauptwort_font` + `state.hauptwort_font_weight`. data-weight wichtig
 * weil Parlare nur Weight 400 hat (kein Bold) — synthetisches Bold zerlegt
 * die Script-Glyphen (User-Bug "kaputtes P"). */
const $styleBtns = document.querySelectorAll('.hauptwort-style-btn');
$styleBtns.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    $styleBtns.forEach(b => b.classList.toggle('current', b === btn));
    setState({
      hauptwort_font: btn.dataset.font,
      hauptwort_font_weight: parseInt(btn.dataset.weight, 10) || 700,
    });
    if (window.matchMedia('(max-width: 900px)').matches) {
      const hauptwort = document.querySelector('.poster-text__hauptwort');
      if (hauptwort) {
        hauptwort.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  });
});


// ===== passepartout.js =====
/* Layout-Tab Picker (Orientation + Passepartout) — Click setzt state.passepartout
 * bzw. visuell die Ausrichtung. V1 = Hochformat-only, Querformat-Klick toggelt
 * nur den Active-State (kein echter Funktionswechsel). */

/* Passepartout-Picker (Layout-Section) */
const $passeItems = document.querySelectorAll('#passe-swatches > li > a');
$passeItems.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    $passeItems.forEach(l => l.classList.toggle('current', l === link));
    setState({ passepartout: link.dataset.passe });
  });
});

/* Orientation-Picker (Hochformat / Querformat) — V1 nur visuell */
const $orientItems = document.querySelectorAll('#orientation-picker > li > a');
$orientItems.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    $orientItems.forEach(l => l.classList.toggle('current', l === link));
    /* V1: kein echter State-Change (nur Hochformat unterstuetzt) */
  });
});


// ===== filter.js =====
/* Foto-Filter-Wahl — 7 Thumbnails (mit Live-Foto-Vorschau pro Filter).
 * Click setzt state.filter; bei Foto-Upload wird der src auf alle
 * Thumbnail-Bilder gesetzt damit der User sieht wie das Foto pro Filter
 * aussehen wuerde. Picker initial display:none, sichtbar nach Upload. */

const $picker = document.getElementById('filter-picker');
const $items = document.querySelectorAll('#filter-options > li > a');
const $thumbImgs = document.querySelectorAll('.filter-thumb-img');

$items.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    $items.forEach(l => l.classList.toggle('current', l === link));
    setState({ filter: link.dataset.filter });
  });
});

/* Filter-Picker IMMER sichtbar — Thumbnails zeigen das Mockup-Foto wenn
 * noch nichts hochgeladen ist (User soll Filter ausprobieren koennen). */
function syncThumbs(s) {
  /* Picker bleibt sichtbar (keine display-Manipulation mehr) */
  const mockup = document.querySelector('.poster-photo__mockup');
  const thumbSrc = s.photo_url || (mockup && mockup.src) || '';
  if (thumbSrc) {
    $thumbImgs.forEach(img => {
      if (img.src !== thumbSrc) img.src = thumbSrc;
    });
  }
}
subscribe(syncThumbs);
syncThumbs(state);


// ===== inspirations.js =====
/* Inspirations-Slide-in-Panel (Pattern Sternkarte).
 * Trigger-Link "Inspiration" oeffnet Panel rechts; Click auf Template
 * fuellt Felder via setState und schliesst Panel automatisch. */

const $cats = document.getElementById('inspirations-cats');
const $list = document.getElementById('inspirations-list');
const $panel = document.getElementById('inspirations-panel');
const $backdrop = document.getElementById('inspirations-backdrop');
const $openBtn = document.getElementById('open-inspirations');
const $closeBtn = document.getElementById('close-inspirations');

let data = null;
let activeCat = null;

function openPanel() {
  if ($panel) {
    $panel.classList.add('is-open');
    $panel.setAttribute('aria-hidden', 'false');
  }
  if ($backdrop) $backdrop.classList.add('is-open');
}
function closePanel() {
  if ($panel) {
    $panel.classList.remove('is-open');
    $panel.setAttribute('aria-hidden', 'true');
  }
  if ($backdrop) $backdrop.classList.remove('is-open');
}

/* Click auf Backdrop schliesst */
if ($backdrop) {
  $backdrop.addEventListener('click', closePanel);
}

if ($openBtn) {
  $openBtn.addEventListener('click', e => {
    e.preventDefault();
    openPanel();
  });
}
if ($closeBtn) {
  $closeBtn.addEventListener('click', e => {
    e.preventDefault();
    closePanel();
  });
}
/* ESC schliesst */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closePanel();
});

// WICHTIG: Funktion heisst initInspirations (nicht init) — siehe analoger
// Kommentar in photo-upload.js. IIFE-Bundle-Scope vermeidet Hoisting-Konflikt.
function initInspirations() {
  // Inline-Daten (oben im Bundle als __INSPIRATIONS_DATA__) — kein fetch
  // mehr noetig, weil die JSON nicht als separates Asset deployed ist.
  data = __INSPIRATIONS_DATA__;
  renderCategories();
  /* Default-Category aus Section-Setting (window.DEFINITION_DEFAULTS) —
   * pro Anlass (Mama / Papa / Oma / etc) andere Initial-Tab-Auswahl. */
  const defaultCat = (window.DEFINITION_DEFAULTS && window.DEFINITION_DEFAULTS.inspirations_category) || data.categories[0].id;
  setActive(defaultCat);
}

function renderCategories() {
  $cats.innerHTML = data.categories
    .map(c => `<li><a href="#" data-id="${c.id}">${c.label}</a></li>`)
    .join('');
  $cats.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', e => {
      e.preventDefault();
      setActive(a.dataset.id);
    });
  });
}

function setActive(id) {
  activeCat = id;
  $cats.querySelectorAll('a').forEach(a => {
    a.classList.toggle('current', a.dataset.id === id);
  });
  renderTemplates();
}

function renderTemplates() {
  const tpls = (data.templates || {})[activeCat] || [];
  $list.innerHTML = tpls
    .map((t, i) => `
      <li>
        <a href="#" data-idx="${i}">
          <span class="tpl-title">${t.title}</span>
          <span class="tpl-snippet">${escapeHtml(truncate(t.definition_p1, 110))}</span>
        </a>
      </li>
    `)
    .join('');
  $list.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', e => {
      e.preventDefault();
      applyTemplate(tpls[+a.dataset.idx]);
    });
  });
}

function applyTemplate(t) {
  if (!t) return;
  // definition_p1 + definition_p2 zusammenfuehren — \n\n trennt Paragraphen
  const def = [t.definition_p1, t.definition_p2].filter(Boolean).join('\n\n');
  setState({
    hauptwort: t.hauptwort || '',
    phonetik: t.phonetik || '',
    definition: def,
    definition_title: t.title || '',   /* Schlagwort fuer Cart-Display */
    synonyme: t.synonyme || '',
  });
  closePanel();
}

function truncate(s, n) {
  if (!s) return '';
  return s.length > n ? s.slice(0, n).trim() + '…' : s;
}
function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}

initInspirations();


// ===== main.js =====
/* Module-Imports — State + Render starten von selbst (subscribe + initial render). */








/* Tab-Switching — Pattern aus distantlines starmap.js / photo.js
 *
 * data-tab="layout__wrapper" auf <a> -> zeigt .layout__wrapper, blendet
 * alle anderen Tab-Wrapper aus. Aktiver Tab bekommt .current. */

const tabLinks = document.querySelectorAll('.main__switcher > ul > li > a');
const tabWrappers = document.querySelectorAll(
  '.layout__wrapper, .text__wrapper, .produkt__wrapper'
);

function activateTab(target) {
  tabLinks.forEach(l => l.classList.toggle('current', l.dataset.tab === target));
  tabWrappers.forEach(wrapper => {
    wrapper.style.display = wrapper.classList.contains(target) ? '' : 'none';
  });

  /* V9.96.28c: Beim ERSTEN Aufruf des Produkt-Tabs automatisch Holzrahmen
   * (data-id=2) auswählen — analog Citymap V9.96.8 / Sternkarte V9.96.27c.
   * Default in Layout/Text-Tabs: Mattes Poster. Im Produkt-Tab: Holzrahmen-Push. */
  if (target === 'produkt__wrapper' && !window.__mamaFormatTabVisited) {
    window.__mamaFormatTabVisited = true;
    const framedTile = document.querySelector('.definition-customizer #type-picker > li > a[data-id="2"]:not(.current)');
    if (framedTile) {
      framedTile.click();
    }
  }

  /* Editor zurueck nach oben scrollen damit User den Anfang vom neuen Tab sieht */
  const switcher = document.querySelector('.main__switcher');
  if (switcher) switcher.scrollTop = 0;
  /* Mobile: Tab-Bar an den Top des Viewports scrollen — 1:1 photo.js
   * initTabSwitching/initWeiterNav (Z. 295-302). Der Switcher selbst
   * wird zum „Stopper" beim Hochscrollen. */
  if (window.matchMedia('(max-width: 900px)').matches && switcher) {
    switcher.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

tabLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    activateTab(link.dataset.tab);
  });
});

/* Weiter-Buttons am Ende von Layout-/Text-Tab */
document.querySelectorAll('.weiter-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    activateTab(btn.dataset.targetTab);
  });
});

})();
